import { styled } from '@mui/material/styles';
import { FranchiseTabBar } from 'views/information-module/common/components/UI/FranchiseTabBar';

const FranchiseHorizontalTabBar = styled(FranchiseTabBar)(({ theme }) => ({
  '& .MuiTab-root': {
    color: theme.palette.grey[300],

    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: '500',
    },
  },
}));
export { FranchiseHorizontalTabBar };
